export default __webpack_public_path__ + "static/media/sort-down-solid.4ea39ef8.svg";